import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const PaymentGateways = () => {
  return (
    <>
          <Box className="headingBtnWrap">
            <Typography variant="h1">Payment Gateways</Typography>
          </Box>
        </>
  )
}

export default PaymentGateways
